// extracted by mini-css-extract-plugin
export default {"container":"_2hqg","text":"_3mnA","alert":"_2fg0","email":"_2HuM","emailList":"Ezvh","inviteLimit":"_2IBT"};